/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable react/no-children-prop */
/* eslint-disable react/prop-types */
/* eslint-disable react/jsx-one-expression-per-line */
import React from 'react';

import { lighten, FormLabel, FormHelperText, FormControl, Typography } from '@mui/material';
import { makeStyles } from 'tss-react/mui';

import { Field, getIn } from 'formik';
import moment from 'moment';

const useStyles = makeStyles()((theme) => ({
  formControl: {
    margin: theme.spacing(1),
    flex: 1,
  },
  dayUnselectedContainer: {
    marginLeft: '2px',
    marginRight: '2px',
    flexGrow: 1,
    borderRadius: 3,
    border: `1px solid ${lighten(theme.palette.primary.light, 0.5)}`,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: 35,
    cursor: 'pointer',
    '&:hover': {
      border: `1px solid ${theme.palette.primary.main}`,
      backgroundColor: lighten(theme.palette.primary.light, 0.9),
    },
  },
  daySelectedContainer: {
    marginLeft: '2px',
    marginRight: '2px',
    flexGrow: 1,
    borderRadius: 3,
    border: theme.palette.primary.light,
    background: theme.palette.primary.main,
    color: theme.palette.primary.contrastText,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: 35,
    cursor: 'pointer',
    '&:hover': {
      backgroundColor: theme.palette.primary.dark,
      boxShadow:
        '0px 2px 4px -1px rgba(0,0,0,0.2), 0px 4px 5px 0px rgba(0,0,0,0.14), 0px 1px 10px 0px rgba(0,0,0,0.12)',
    },
  },
  container: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
  },
  dayUnselectedText: {
    color: theme.palette.primary.main,
  },
  daySelectedText: {
    color: theme.palette.primary.contrastText,
  },
  label: { transform: 'translate(-2px, 0) scale(0.9)', marginBottom: '4px' },
}));

const WEEK_DAYS_JAVA_STYLE = [7, 1, 2, 3, 4, 5, 6];

export const RenderWeekDaySelector = (props) => {
  const {
    field,
    form: { touched, errors, setFieldValue, values },
    label,
  } = props;

  const { classes } = useStyles();
  const touch = getIn(touched, field.name);
  const error = getIn(errors, field.name);
  const myValues = getIn(values, field.name);

  return (
    <FormControl
      variant="standard"
      error={touch && error != null}
      component="fieldset"
      className={classes.formControl}
    >
      <FormLabel component="legend" className={classes.label}>
        {label}
      </FormLabel>

      <div className={classes.container}>
        {WEEK_DAYS_JAVA_STYLE.map((weekDay) => {
          const isSelected = myValues?.includes(weekDay);
          return (
            <div
              key={weekDay}
              className={isSelected ? classes.daySelectedContainer : classes.dayUnselectedContainer}
              onClick={() => {
                if (myValues?.includes(weekDay)) {
                  setFieldValue(
                    field.name,
                    myValues.filter((pValue) => pValue !== weekDay),
                  );
                } else {
                  setFieldValue(field.name, myValues != null ? myValues.concat([weekDay]) : [weekDay]);
                }
              }}
            >
              <Typography
                className={isSelected ? classes.daySelectedText : classes.dayUnselectedText}
                variant="button"
              >
                {moment().weekday(weekDay).format('ddd')}
              </Typography>
            </div>
          );
        })}
      </div>
      {touch && error && <FormHelperText>{error}</FormHelperText>}
    </FormControl>
  );
};
export const FormWeekDaySelector = ({ name, dataSource, ...others }) => (
  <Field name={name} component={RenderWeekDaySelector} {...others} />
);
